<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
  style="background:url(assets/images/background/login-register.jpg) no-repeat center center;">
  <div class="auth-box m-3 m-md-0">
    <div id="">
      <div class="logo">
        <span class="db"><img src="assets/images/logo-icon.png" alt="logo" /></span>
        <h5 class="font-medium m-b-20">Recover Password</h5>
        <span>Enter your Email and instructions will be sent to you!</span>
      </div>
      <div class="row m-t-20">
        <div class="col-12">
          <div class="form-group row">
            <div class="col-12">
              <input [(ngModel)]="email" class="form-control form-control-lg" type="email" required="" placeholder="Email">
            </div>
          </div>
          <div class="row m-t-20">
            <div class="col-12">
              <button class="btn btn-block btn-lg btn-danger" type="submit" (click)="Reset()" name="action">Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
